export default {
  title: "Shortcut Keys",
  userHelp: "User Help",
  canvasOperationTip: {
    title: "Canvas Operation Tips",
    tooltip: "Step-by-step tips when operating nodes on the canvas",
  },
  reopenUserGuide: "View User Guide Again",
  shortcuts: {
    selectAll: {
      label: "Select All",
      key: "ctrl+A/⌘+A",
    },
    multiSelect: {
      label: "Multi Select",
      key: "ctrl/⌘+Left click to select multiple nodes",
    },
    boxSelect: {
      label: "Box Select",
      key: "Right click to box select multiple nodes",
    },
    previousStep: {
      label: "Previous Step",
      key: "ctrl+Z/⌘+Z",
    },
    nextStep: {
      label: "Next Step",
      key: "ctrl+F/⌘+F",
    },
    expandDetails: {
      label: "Expand Details",
      description: "(Node/Transaction edge details)",
      key: "ctrl+E/⌘+E",
    },
    saveCanvas: {
      label: "Save Canvas",
      key: "alt+S/⌥+S",
    },
    nodeRemark: {
      label: "Node Remark",
      description: "(At least one node selected)",
      key: "alt+V/⌥+V",
    },
    copyAddress: {
      label: "Copy Address",
      description: "(At least one node selected)",
      key: "ctrl+C/⌘+C",
    },
    deleteNode: {
      label: "Delete Node",
      description: "(At least one node selected)",
      key: "Delete",
    },
    newCanvas: {
      label: "New Canvas",
      description: "(At least one node selected)",
      key: "alt+G/⌥+G",
    },
    addMonitor: {
      label: "Add to Monitor",
      description: "(One node selected)",
      key: "ctrl+M/⌘+M",
    },
    directAssociation: {
      label: "Direct Association",
      description: "(Multiple nodes selected)",
      key: "ctrl+R/⌘+R",
    },
    batchExpand: {
      label: "Batch Expand",
      description: "(Multiple nodes selected)",
      key: "enter/return",
    },
  },
};
